import { OnSchedUtils } from ".";

export const successToastMsgs = ({
  location: {
    Post: { error: false, message: 'Your Location has been created successfully.' },
    Put: { error: false, message: 'Your Location has been successfully updated.' },
    Delete: { error: false, message: 'Your Location has been removed.' },
  },
  resource: {
    Post: { error: false, message: 'Your Resource has been created successfully.' },
    Put: { error: false, message: 'Your Resource has been successfully updated.' },
    Delete: { error: false, message: 'Your Resource has been removed.' },
  },
  service: {
    Post: { error: false, message: 'Your Service has been created successfully.' },
    Put: { error: false, message: 'Your Service has been successfully updated.' },
    Delete: { error: false, message: 'Your Service has been removed.' },
  },
})

export const Toast = (element, toast) => {
  const el = document.getElementById(element.id);

  const elToast = document.createElement('DIV');
  elToast.className = 'Toast';

  const elToastIcon = document.createElement('I');
  elToastIcon.classList.add('fa-duotone');

  const elToastClose = document.createElement('I');
  elToastClose.className = 'closeToast fa-thin fa-xmark';
  elToastClose.onclick = () => {
    elToast.classList.add('fading');
    setTimeout(() => {
      elToast.remove();
    }, 300);
  }
  
  const elToastMessage = document.createElement('H5');

  elToastMessage.innerText = OnSchedUtils.Internationalize(element, 'error');
  
  if (toast.message) {
    elToastMessage.innerText = toast.message;
  }

  if (toast.error) {
    elToastIcon.classList.add('fa-triangle-exclamation');
    elToast.classList.add('Error');
    if (toast.data?.errors?.length) {
      elToastMessage.innerText = toast.data.errors.map(e => e.error).join(' ');
    }
  }
  else {
    elToastIcon.classList.add('fa-circle-check');
  }

  elToast.append(elToastIcon);
  elToast.append(elToastMessage);
  elToast.append(elToastClose);

  
  el.appendChild(elToast);
  
  elToast.slideWidth =  elToast.clientWidth + 'px';
  elToast.classList.add('slideIn');

  // setTimeout(() => {
  //   elToast.classList.add('fading');
  // }, 3700);

  // setTimeout(() => {
  //   elToast.remove();
  // }, 4000);
}
